module.exports = __webpack_public_path__ + "static/img/calculator.da5308f.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/calculator.png
// module id = kKj1
// module chunks = 1